import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "job-posting"
    }}>{`Job Posting`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Job postings are usually limited to text-based content, but often additional supporting documents, such as PDF brochures, can better communicate the opportunity or the company.`}</p>
    <p>{`Adobe Acrobat Services allows job sites to:`}</p>
    <ul>
      <li parentName="ul">{`Show and render high-resolution supporting documents`}</li>
      <li parentName="ul">{`Access analytics to understand what documents candidates are most interested in`}</li>
    </ul>
    <p>{`In addition, Adobe Acrobat Services allows for documents uploaded in different formats, such as Microsoft Word, to be normalized into the PDF format.`}</p>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`An HR manager logs into a job posting site. After entering information about an available position, the manager uploads supporting documents, such as documents about the department, the company, and the solutions involved. The website then renders the job posting and the documents inline.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a PDF document from multiple file types using Adobe PDF Services API Create PDF operation`}</li>
      <li parentName="ol">{`Process the document with PDF Services API OCR and Compress operations to streamline and normalize`}</li>
      <li parentName="ol">{`Pass the document to Extract API to extract data and send on through the system`}</li>
      <li parentName="ol">{`Use Adobe PDF Embed API to render the PDF on the submission page, inline`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      